/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brokers: NonNullable<unknown>, offers: NonNullable<unknown> }} Ebr_Conn_Test_OkInputs */

const cs_ebr_conn_test_ok = /** @type {(inputs: Ebr_Conn_Test_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Připojení funguje: ${i?.brokers} makléřů, ${i?.offers} nabídek`)
};

const en_ebr_conn_test_ok = /** @type {(inputs: Ebr_Conn_Test_OkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connection works: ${i?.brokers} brokers, ${i?.offers} offers`)
};

/**
* | output |
* | --- |
* | "Connection works: {brokers} brokers, {offers} offers" |
*
* @param {Ebr_Conn_Test_OkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conn_test_ok = /** @type {((inputs: Ebr_Conn_Test_OkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conn_Test_OkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conn_test_ok(inputs)
	return cs_ebr_conn_test_ok(inputs)
});